import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  useBrandingService,
  BrandingData,
  BrandingUploadRequest,
} from "../services/api/branding-service";
import { useActiveAgent } from "../contexts/ActiveAgentContext";

export function useBrandingData() {
  const service = useBrandingService();
  const { activeAgent } = useActiveAgent();

  return useQuery<BrandingData>({
    queryKey: ["branding", activeAgent?.id],
    queryFn: () => service.fetchBranding(),
    enabled: !!activeAgent?.id,
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: false,
  });
}

export function useUploadBranding() {
  const service = useBrandingService();
  const queryClient = useQueryClient();
  const { activeAgent } = useActiveAgent();

  return useMutation<void, Error, BrandingUploadRequest>({
    mutationFn: (data) => service.uploadBranding(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["branding", activeAgent?.id],
      });
    },
  });
}
